export default __webpack_public_path__ + "src/assets/settings.d5b6a2956f38d3f18f0df5d3a5c10d05.svg";